<!-- eslint-disable -->
<template>
  <span :class="`info-tooltip ${className ? className : ''}`">
    <Tooltip ref="tooltip" :autoHide="true" :triggers="['click']" :popper-triggers="['click']" :delay="{ show: 0, hide: 0 }" :distance="10" :placement="placement" :prevent-overflow="true" :overflow-padding="10">
      <div
        class="info-tooltip__trigger"
        @click="stopAll"
        @mousedown="stopAll"
        @mouseup="stopAll"
        @pointerdown="stopAll"
        @pointerup="stopAll"
      ><span class="icon icon--help form-label-info-icon icon--shakespeare"></span></div>
      <template #popper>
        <div class="info-tooltip__content" v-html="content" />
      </template>
    </Tooltip>
  </span>
</template>

<script src="./InfoTooltip.js"></script>
<!-- eslint-enable -->
